<template>
  <v-dialog
    v-model="isVisibleDialog"
    persistent
    max-width="600px"
  >
    <v-form
      ref="form"
      lazy-validation
    >
      <v-card>
        <v-card-title>
          <span class="text-h3">{{ $t("edit") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="item.date"
                  dense
                  disabled
                  :label="$t('date_*')"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="item.filling_time"
                  dense
                  :label="$t('filling_time_*')"
                  :rules="[rules.required, rules.time]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="item.bus_no"
                  dense
                  :label="$t('bus_no_*')"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="item.reg_no"
                  dense
                  :label="$t('reg_no_*')"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="item.terminal"
                  dense
                  item-value="id"
                  item-text="name"
                  :items="terminalList"
                  :label="$t('terminal_*')"
                  :rules="[rules.required]"
                  @change="
                    () => {
                      item.dispenser = null;
                      item.nozzle = null;
                    }
                  "
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="item.dispenser"
                  dense
                  item-value="id"
                  item-text="dispenser_identifier"
                  :items="dispenserList"
                  :label="$t('dispenser_*')"
                  :rules="[rules.required]"
                  @change="
                    () => {
                      item.nozzle = null;
                    }
                  "
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="item.nozzle"
                  dense
                  item-value="id"
                  item-text="nozzle_number"
                  :items="nozzleList"
                  :label="$t('nozzle_*')"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="item.total_diesel"
                  dense
                  type="number"
                  :label="$t('total_diesel_*')"
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small>{{ $t("indicates_required_field") }}</small>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="toggleEdit()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="isLoadingSave"
            @click="updateItem(item)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { validationRules } from "@/mixins/validationRules";

export default {
  mixins: [validationRules],
  props: {
    isVisibleDialog: Boolean,
    toggleEdit: {
      type: Function,
      default() {
        return void 0;
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      isLoadingSave: false,
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      //   tenantLoading: "tenantsManagement/getIsLoading",
      //   tenantsOEM: "tenantsManagement/getTenantsOEM",
      //   tenantsFLEET: "tenantsManagement/getTenantsFLEET",
      //
      terminalList: "terminal/getList",
      dList: "fuelDispenser/getList",
    }),

    dispenserList() {
      const arr =
        this.dList.filter((r) => r.terminal_id == this.item.terminal) || [];
      return arr;
    },
    nozzleList() {
      const dRow = this.dList.find((r) => r.id == this.item.dispenser);
      return dRow?.nozzles || [];
    },
  },
  async mounted() {
    // if (!this.authUser.isAdmin) {
    // }
    this.getTerminal();
    // this.getDispenser();
  },
  methods: {
    async updateItem(row) {
      if (this.$refs.form.validate()) {
        this.isLoadingSave = true;
        await this.$store
          .dispatch("dataLogs/update", row)
          .then(() => {
            this.$store.dispatch(
              "alerts/success",
              this.$t("updated_successfully")
            );
            this.isLoadingSave = false;
            this.toggleEdit();
          })
          .catch((error) => {
            this.$store.dispatch("alerts/error", error.response?.data?.message);
            this.isLoadingSave = false;
          });
      }
    },

    getTerminal() {
      this.$store.dispatch("terminal/list", { tenant_id: this.item.tenant });
      this.getDispenser(this.item.terminal);
    },
    getDispenser(v) {
      this.$store.dispatch("fuelDispenser/list", { terminal_id: v });
    },
  },
};
</script>
